(function () {

    'use strict';
    var recaptcha;
    var formValidator;

    var submitForgotPwForm = function (captcha, form) {
        var btn = $(this);

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            var url = '/action/pmiForgetPassword';

            url += '?ajax=true';
            url += '&email=' + encodeURIComponent(form.find('input[name=email]').val());
            if (captcha) {
                url += '&captcha=' + captcha;
            }

            btn.addClass('disabled');
            form.find('.forgot-pw-success, .forgot-pw-error').slideUp();

            ajax(url, function (response) {
                btn.removeClass('disabled');
                if (response.indexOf('success') > -1) {
                    form.find('input').val('').removeClass('has-value');
                    form.find('.forgot-pw-success').slideDown(function () {
                        setTimeout(function () {
                            form.find('.forgot-pw-success').slideUp();
                        }, 15000);
                    });
                } else {
                    form.find('.forgot-pw-error').slideDown();
                }
            }, true);
        }
    };

    var convertRequiredLogLinks = function () {
        var url = $('.page').attr('data-page-login');
        if (url && url !== '' && !$('body').hasClass('is-signed-in')) {
            $('a.required-log').attr("href", url);
        }
    };

    var init = function () {
        recaptcha = Fw.component.models().utils.recaptcha;
        formValidator = Fw.component.models().form;

        $('.submit-forgot-pw-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                submitForgotPwForm.call(btn, response, form);
            }, true, $(this).closest('form'));
        });

        convertRequiredLogLinks();
    };

    $(window).ready(init);

})();
